import { Moment } from "moment";
import { TipoMotivacao } from "./tipo-motivacao.model";
import { AnoBase } from "./ano-base.model";
import { TipoMedidaAplicada } from "./tipo-medida-aplicada.model";

export class GerirEmissaoCartaCredito {

  id: number;
  idEntidade: number;
  alteracaoMotivadaRecurso: boolean;
  nrPortaria: number;
  dataPublicacaoPortaria: Moment;
  notificaReceitaFederal: boolean;
  tipoMotivacao: TipoMotivacao;
  tipoMedidaAplicada: TipoMedidaAplicada;
  justificativa: string;
  anoBase: AnoBase;
  dataInicio: Moment;
  dataFim: Moment;
  valorDeduzidoPPB: number;
  valorDeduzidoPeD: number;
  idSituacaoEntidade: number;

}
